import { render } from "./RegistrationReasonsListing.vue?vue&type=template&id=7c70204e&ts=true"
import script from "./RegistrationReasonsListing.vue?vue&type=script&lang=ts"
export * from "./RegistrationReasonsListing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__